import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text,
  Button,
  VStack,
  useToast,
  Icon,
} from '@chakra-ui/react';
import useQuarterlyReportingApi from '@src/modules/performance/api/useQuarterlyReportingApi';
import { FiDownloadCloud } from 'react-icons/fi';

function GeneratedReports({
  isOpen, onClose, reportList,
}) {
  const api = useQuarterlyReportingApi();
  const toast = useToast();

  const handleClose = () => {
    onClose();
  };

  const handleDownloadReport = async (report) => {
    const fileName = `Quarterly_Report_${report?.lockYear}_Q${report?.quarter}_(${new Date(report?.createdDate).toLocaleString('en-NZ', { dateStyle: 'medium', timeStyle: 'short' })})`;
    try {
      await api.downloadQuarterlyReport(report?.lockYear, report?.quarter, report?.id)
        .then((res) => {
          const file = new Blob(
            [res],
            { type: 'application/zip' },
          );
          const url = URL.createObjectURL(file);
          const link = document.createElement('a');
          link.href = url;
          link.download = `${fileName}.zip`;
          link.click();
          URL.revokeObjectURL(url);
        });
    } catch (err) {
      console.log(err);
      toast({
        title: 'Error',
        description: 'An error occurred while downloading the report.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          Generated Reports
          {' '}
          {reportList?.[0]?.lockYear}
          {' '}
          Q
          {reportList?.[0]?.quarter}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={4}>
          {reportList.length === 0 && (
            <Text>No reports have been generated</Text>
          )}
          {reportList.length > 0 && (
            <VStack spacing={4} align="flex-start">
              {reportList.map((report) => (
                <Button
                  key={report.id}
                  leftIcon={<Icon as={FiDownloadCloud} boxSize={4} />}
                  onClick={() => handleDownloadReport(report)}
                  variant="link"
                  size="sm"
                >
                  {`Quarterly Report ${report?.lockYear} Q${report?.quarter} (${new Date(report?.createdDate).toLocaleString('en-NZ', { dateStyle: 'medium', timeStyle: 'short' })}).zip`}
                </Button>
              ))}
            </VStack>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default GeneratedReports;
